// Load css file
const loadCss = (fileName) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    const fileId = `${fileName.toUpperCase()?.replace('-', '')}CSS`;
    const mainPath = document.getElementById('MainCssPath').href;
    link.onload = resolve;
    link.onerror = reject;
    link.id = fileId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = mainPath.includes('?v')
      ? mainPath.split('?v')[0]?.replace('/assets/main.css', `/assets/${fileName}.css`)
      : mainPath.replace('/assets/main.css', `/assets/${fileName}.css`);
    link.media = 'all';
    if (!document.getElementById(fileId)) {
      document.head.appendChild(link);
    }
  });
};
// Load js file
const loadScript = (fileName) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    const fileId = `${fileName.toUpperCase()?.replace('-', '')}JS`;
    const mainPath = document.getElementById('MainJsPath').src;
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.id = fileId;
    script.type = 'text/javascript';
    script.src = mainPath.includes('?v')
      ? mainPath.split('?v')[0]?.replace('/assets/main.js', `/assets/${fileName}.js`)
      : mainPath.replace('/assets/main.js', `/assets/${fileName}.js`);
    if (!document.getElementById(fileId)) {
      document.head.appendChild(script);
    }
  });
};
// Scroll animation observer
const scrollAnimationObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-animation--active');
        scrollAnimationObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.25,
  }
);

(function scrollAnimationInit() {
  if (!document.documentElement.classList.contains('js-scroll-animations')) return;

  document.querySelectorAll('.scroll-animation').forEach((el, i) => {
    scrollAnimationObserver.observe(el);
  });
})();
// Add helper class when announcement bar is enabled
window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.announcement-bar') != null) {
    document.body.classList.add('is-announcement-bar');
  }
});
// Helper functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .drawer, modal-dialog"
    )
  );
}
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}
// Details animation
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.classList.remove('details--active');
  summaryElement.setAttribute('aria-expanded', false);
  setTimeout(() => {
    openDetailsElement.removeAttribute('open');
  }, 500);
  if (summaryElement.classList.contains('mmenu__hamburger') && document.body.classList.contains('mmenu--open')) {
    document.body.classList.remove('mmenu--open');
  }
  summaryElement.focus();
}
class Accordion {
  constructor(el) {
    this.details = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.details__content');

    this.summary.addEventListener('click', (event) => this.onClick(event));
    this.details.addEventListener('keyup', onKeyUpEscape);
    window.addEventListener('DOMContentLoaded', this.mobileOnlyDetails());
    window.addEventListener('resize', () => {
      this.mobileOnlyDetails();
    });
  }

  onClick(event) {
    event.preventDefault();
    event.currentTarget.setAttribute('aria-expanded', !this.details.hasAttribute('open'));

    if (this.details.hasAttribute('open')) {
      this.collapse();
    } else {
      this.expand();
    }

    if (this.summary.classList.contains('mmenu__hamburger')) {
      document.body.classList.toggle('mmenu--open');
    }
  }

  collapse() {
    this.details.classList.remove('details--active');
    setTimeout(() => {
      this.details.removeAttribute('open');
    }, 500);
  }

  expand() {
    this.details.setAttribute('open', '');
    setTimeout(() => {
      this.details.classList.add('details--active');
    }, 250);
  }

  mobileOnlyDetails() {
    if (this.details.classList.contains('mobile--only')) {
      if (window.innerWidth < 769) {
        this.collapse();
      } else {
        this.expand();
      }
    }
  }
}
document.querySelectorAll('[id^="Details-"]').forEach((el) => {
  new Accordion(el);
});
// Check if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const variantImage = this.currentVariant.featured_media.preview_image.src;

    if (this.closest('.product-card')) {
      const media = this.closest('.product-card').querySelector('.product-card__media .media--primary');
      media.innerHTML = `<img src="${variantImage}&width=1440">`;
    } else {
      const carousel = document.querySelector('#main-carousel');
      if (!carousel) return;
      const media = carousel.querySelector(
        `.splide__slide[data-media-position="${this.currentVariant.featured_media.position}"]`
      );
      const mediaContainer = carousel.querySelector('.splide__list');

      if (carousel.classList.contains('is-active')) {
        var Slides = main.Components.Slides.filter('.product__media-item');

        if (Slides[this.currentVariant.featured_media.position - 1]) {
          if (carousel.classList.contains('splide--loop')) {
            main.go(Slides[this.currentVariant.featured_media.position + 1].index);
          } else {
            main.go(Slides[this.currentVariant.featured_media.position - 1].index);
          }
        }
      } else {
        media.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      }
    }
  }

  updateURL() {
    if (!this.closest('.product-wrapper') || !this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    const urlInput = shareButton.querySelector('input');
    let urlToShare = urlInput ? urlInput.value : document.location.href;
    const url = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
    urlToShare = url;
    urlInput.value = url;
  }

  updateVariantInput() {
    if (this.closest('.product-card')) {
      if (this.closest('form')) {
        const productCardInput = this.closest('form').querySelector('input[name="id"]');
        productCardInput.value = this.currentVariant.id;
        productCardInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);        
      this.setInputAvailability(optionInputs, availableOptionInputsValue);

      // Update slected option label
      this.querySelectorAll(':checked').forEach((el) => {
        if (el.closest('.product-form__input').querySelector('#selectedOption')) {
          el.closest('.product-form__input').querySelector('#selectedOption').textContent = el.value;
        }
      });
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.style.display = 'block';
    } else {
      pickUpAvailability.style.display = 'none';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url.split('?')[0]}.json`)
      .then((response) => response.json())
      .then((data) => {
        const variant = data.product.variants.filter((v) => {
          return v.id === this.currentVariant.id;
        });

        const symbol = document.querySelectorAll('.price-item')[0].innerHTML.charAt(0);
        let currency = document.querySelectorAll('.price-item')[0].innerHTML.split(' ')[1];
        if (currency == undefined) currency = '';
        let price, compare_price, saleBadge;
        const soldOutBadge = document.querySelector('.product__info .badge--sold');
        let compare_at_price = variant[0].compare_at_price;

        if (this.closest('.product-card')) {
          price = this.closest('.product-card').querySelector('.price-item--regular');
          compare_price = this.closest('.product-card').querySelector('.price-item--compare');
          saleBadge = this.closest('.product-card').querySelector('.badge--sale');
        } else {
          price = this.closest('.product__info').querySelector('.price-item--regular');
          compare_price = this.closest('.product__info').querySelector('.price-item--compare');
          saleBadge = this.closest('.product__info').querySelector('.badge--sale');
        }

        if (price.closest('.price').querySelector('.price-varies__label')) {
          price.closest('.price').querySelector('.price-varies__label').remove();
        }

        if (compare_at_price && Number(compare_at_price) > Number(variant[0].price)) {
          if (compare_price) {
            compare_price.innerHTML = symbol + compare_at_price + ' ' + currency;
          } else {
            const comparePriceNew = document.createElement('s');
            comparePriceNew.className += 'price-item price-item--compare';
            comparePriceNew.textContent = symbol + compare_at_price + ' ' + currency;

            const saleBadgeNew = document.createElement('span');
            saleBadgeNew.className += 'badge badge--sale';
            saleBadgeNew.textContent = 'Sale';

            price
              .closest('.price-item--regular')
              .parentNode.insertBefore(comparePriceNew, price.closest('.price-item--regular').nextSibling);

            if (!this.closest('.product-card')) {
              price.closest('.price-item--regular').parentNode.insertBefore(saleBadgeNew, comparePriceNew.nextSibling);
            }
          }
        } else {
          if (compare_price) compare_price.remove();
          if (saleBadge) saleBadge.remove();
        }

        price.textContent = symbol + variant[0].price + ' ' + currency;

        if (!this.currentVariant.available) {
          if (soldOutBadge) {
            soldOutBadge.removeAttribute('hidden');
          } else {
            const soldOutBadgeNew = document.createElement('span');
            soldOutBadgeNew.className += 'badge badge--sold';
            soldOutBadgeNew.textContent = 'Sold Out';

            if (!this.closest('.product-card')) {
              price.closest('.price').append(soldOutBadgeNew);
            }
          }
        } else {
          if (soldOutBadge) {
            soldOutBadge.setAttribute('hidden', '');
          }
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let productForm;

    if (this.closest('.product-card')) {
      productForm = this.closest('form');
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');      
      if (this.closest('.product-wrapper')?.dataset.preorder) {
        addButtonText.textContent = 'Preorder Now';
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    let productForm;
    if (this.closest('.product-card')) {
      productForm = this.closest('form');
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (addButton) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }

    if (addButton.hasAttribute('hidden')) {
      addButton.removeAttribute('hidden');
      setTimeout(() => addButton.setAttribute('hidden', ''), 3000);
    } else {
    }
  }

  setPreorder() {
    let productForm;

    if (this.closest('.product-card')) {
      productForm = this.closest('form');
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (addButton) {
      addButtonText.textContent = window.variantStrings.preorder; // Assuming this is where your preorder text is stored
    }
    if (addButton.hasAttribute('hidden')) {
      addButton.removeAttribute('hidden');
      setTimeout(() => addButton.setAttribute('hidden', ''), 3000);
    } else {
    }
  }  

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {        
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('sold-out');
      } else {
        input.classList.add('sold-out');
      }
    });
  }


  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });    
  }
}
customElements.define('variant-radios', VariantRadios);
class MainDrawer extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger');
    this.drawer = this.querySelector('.drawer');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDrawer());
    this.querySelectorAll('.drawer-close').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.openDrawer());
    }

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector('.drawer__container'));
    }, 300);
  }

  openDrawer() {
    this.setFocus();
    this.drawer.classList.add('drawer--active');
    document.body.classList.add('drawer--open');
  }

  closeDrawer() {
    this.drawer.classList.remove('drawer--active');
    setTimeout(() => {
      document.body.classList.remove('drawer--open');
    }, 500);
    document.activeElement.blur();
  }
}
customElements.define('main-drawer', MainDrawer);
class DetailsDrawer extends MainDrawer {
  constructor() {
    super();

    this.details = this.querySelector('details');
  }

  closeDrawer() {
    this.drawer.classList.remove('drawer--active');
    setTimeout(() => {
      document.body.classList.remove('drawer--open');
      this.details.removeAttribute('open');
    }, 500);
    document.activeElement.blur();
  }
}
customElements.define('details-drawer', DetailsDrawer);
class SearchDrawer extends MainDrawer {
  constructor() {
    super();

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector('.search-drawer'));
      document.getElementById('SearchInput').focus();
    }, 300);

    document.getElementById('SearchDrawerTrigger').addEventListener('click', (e) => {
      this.openDrawer();
      this.setFocus();
      if (!document.getElementById('PREDICTIVESEARCHCSS') && document.getElementById('PREDICTIVESEARCHJS')) {
        this.classList.add('loading');
      }
      if (this.querySelector('predictive-search')) {
        loadScript('predictive-search').catch((error) => {
          console.error(error);
        });
        loadCss('predictive-search')
          .then(() => {
            this.classList.remove('loading');
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }
}
customElements.define('search-drawer', SearchDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.hide());
    this.querySelectorAll('.modal__close').forEach((el) => el.addEventListener('click', () => this.hide()));
    this.querySelector('.modal-trigger').addEventListener('click', this.show.bind(this));
  }

  hide() {
    this.querySelector('dialog').removeAttribute('open');
    this.querySelector('.modal').classList.remove('modal--active');
    document.body.classList.remove('modal--open');
    removeTrapFocus(this);
  }

  show() {
    this.querySelector('dialog').setAttribute('open', '');
    this.querySelector('.modal').classList.add('modal--active');
    document.body.classList.add('modal--open');
    trapFocus(this);
  }
}
customElements.define('modal-dialog', ModalDialog);
class SearchDialog extends ModalDialog {
  constructor() {
    super();

    this.querySelector('.modal-trigger').addEventListener('click', this.loadAssets.bind(this));
  }

  loadAssets() {
    this.show();
    setTimeout(() => {
      document.getElementById('SearchInput').focus();
    }, 500);
    if (!document.getElementById('PREDICTIVESEARCHCSS') && !document.getElementById('PREDICTIVESEARCHJS')) {
      this.classList.add('loading');
    }
    if (this.querySelector('predictive-search')) {
      loadScript('predictive-search').catch((error) => {
        console.error(error);
      });
      loadCss('predictive-search')
        .then(() => {
          this.classList.remove('loading');
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
customElements.define('search-dialog', SearchDialog);
// Back to top
(function backToTop() {
  const trigger = document.querySelector('.btn--back-to-top');

  if (trigger) {
    const backToTopReveal = (e) => {
      if (window.pageYOffset >= 50) {
        trigger.classList.add('btn--back-to-top__revealed');
      } else {
        trigger.classList.remove('btn--back-to-top__revealed');
      }
    };

    backToTopReveal();
    window.addEventListener('scroll', backToTopReveal);

    trigger.addEventListener('click', (e) => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
})();

// Page transition
window.addEventListener('beforeunload', () => {
  document.body.classList.add('unloading');
});
window.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('loaded');
});
window.addEventListener('pageshow', (event) => {
  // Removes unload class when returning to page via history
  if (event.persisted) {
    document.body.classList.remove('unloading');
  }
});

const productFormObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadScript('product-form').catch((error) => {
          console.error(error);
        });
        productFormObserver.unobserve(entry.target);
      }
    });
  },
  { rootMargin: '0px 0px 250px 0px' }
);

document.querySelectorAll('[product-form-oberver]').forEach((el) => productFormObserver.observe(el));

const imageObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('loaded');
        imageObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.25 }
);

document.querySelectorAll('img[loading="lazy"]').forEach((el) => imageObserver.observe(el));

// const showStoredItems = () => {
//   const storedItemsList = JSON.parse(window.sessionStorage.getItem('elevated:item-added') || '[]');

//   document.querySelectorAll('.product-card').forEach((el) => {
//     if (storedItemsList.indexOf(parseInt(el.id)) !== -1) {
//       el.classList.add('in-cart');
//     }
//   });
// };

// showStoredItems();

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(`.product-card .splide`).forEach(el => {
    const splide = new Splide(el, {  
      "arrows": true,              
      "arrowPath": "M7.032,21.477,4.5,18.945l8.357-8.21L4.5,2.532,7.032,0l10.89,10.735Z",
      "pagination": false,
      "type": "loop",
      "perPage": 1,          
      "keyboard": true,
      "mediaQuery": "min",
      "flickMaxPages": 1,
      "flickPower": 100,
      "speed": 750,
      "start": 0          
    });       

      splide.on('mounted', function () {        
        const roles = document.querySelectorAll('.splide [role]');
                
        roles.forEach(function (element) {
          element.removeAttribute('role');
        });
      });
      
      splide.mount();      
  })
})

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    const component = document.querySelector('shopify-payment-terms');
    if (component && component.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        p {
          font-family: var(--font-body) !important;
          font-size: 14px !important;
        }
      `;
      component.shadowRoot.appendChild(style);
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
